import React from "react";
import type { ButtonLinkProps } from "@sprout/buttons/types.ts";
import { Link as InertiaLink } from "@inertiajs/react";
import classNames from "classnames";

type InternalButtonLinkProps = ButtonLinkProps & Pick<React.ComponentProps<"a">, "className">;

const InternalButtonLink = ({
  ariaLabel,
  children,
  className,
  disabled = false,
  external = false,
  href,
  onClick,
  shape = "rounded",
  size = "large",
  ...restProps
}: InternalButtonLinkProps) => {
  const mergedClassName = classNames(className, {
    btn: true,
    [`btn--${shape || "rounded"}`]: true,
    [`btn--${size || "large"}`]: true,
    btn__disabled: disabled,
  });

  const Link = external ? "a" : InertiaLink;

  const target = external ? "_blank" : undefined;
  const rel = external ? "noopener noreferrer" : undefined;

  return (
    <Link
      aria-label={ariaLabel}
      className={mergedClassName}
      href={href}
      onClick={onClick}
      rel={rel}
      target={target}
      {...restProps}
    >
      {children}
    </Link>
  );
};

export const PrimaryButtonLink = (props: ButtonLinkProps) => {
  return <InternalButtonLink {...props} className="btn__primary" />;
};

export const SecondaryButtonLink = (props: ButtonLinkProps) => {
  return <InternalButtonLink {...props} />;
};

export const DangerButtonLink = (props: ButtonLinkProps) => {
  return <InternalButtonLink {...props} className="btn__danger" />;
};

export const DestructiveButtonLink = (props: ButtonLinkProps) => {
  return <InternalButtonLink {...props} className="btn__destructive" />;
};
